function samplingAnalysisSelectDirective() {
	return {
		scope : {
			samplingsAnalysisSelected : '=samplingsAnalysis',
			product : '<?',
			requiredProduct : "@?",
			samplingsAnalysisInit : '=?',
			onSamplingAnalysisChange : '&?',
		},
		restrict : 'E',
		replace : true,
		templateUrl : function(elem, attr) {
			return 'views/directives/samplingAnalysisSelectDirective.html';
		},
		controller : [ '$scope', '$window', '$log', '$uibModal', 'alertService', 'regulationService',
				function($scope, $window, $log, $uibModal, alertService, regulationService) {
					var vm = this;
					$scope.availableTechniques = [];
					$scope.technique = {};
					vm.loadInitData = false;

					$scope.someGroupFn = function(item) {
						return 'Normativa: ' + item.analysis.regulation.name;
					};

					$scope.$watch('samplingsAnalysisInit', function(newValue, oldValue) {
						if (!$scope.samplingsAnalysisInit)
							return;
						vm.loadInitData = true;
						$scope.samplingsAnalysisInit.forEach(function(sa) {
							create(sa);
						});
					});

					$scope.$watch('product', function(newValue, oldValue) {
						$scope.searchTechniques();
					});

					$scope.searchTechniques = function(query) {
						// si se requiere el producto y no hay producto valido,
						// no hace la búsqueda
						if (!$scope.requiredProduct && !$scope.product) {
							$scope.availableTechniques = [];
							$scope.techniquesCount = undefined;
							$scope.techniquesLimit = undefined;
							return;
						}
						if ($scope.techniquesCount && $scope.techniquesLimit) {
							if ($scope.techniquesCount <= $scope.techniquesLimit)
								return;
						}
						var filter = {
							'technique.analysis.regulation.active' : "true"
						};
						if (query && query !== '') {
							filter['technique.analysis.regulation.name'] = query;
						}
						if ($scope.product) {
							filter['technique.analysis.regulation.product'] = $scope.product.id;
						}
						if ($scope.samplingsAnalysisSelected && $scope.samplingsAnalysisSelected.length > 0) {
							var ni = $scope.samplingsAnalysisSelected.map(function(sa) {
								return sa.id
							});
							filter['technique.notin'] = ni;
						}
						$scope.loading = true;
						regulationService.searchRegulationAnalysisTechnique(filter).then(function(response) {
							var resp = response.getData();
							$scope.availableTechniques = resp.results;

							if (!$scope.techniquesCount)
								$scope.techniquesCount = resp.totalRegisters;
							$scope.techniquesLimit = resp.limit;

							// si se cargaron datos selecionados mientras se
							// estaba leyendo los datos del servidor
							if (vm.loadInitData && $scope.samplingsAnalysisSelected) {
								vm.loadInitData = false;
								$scope.samplingsAnalysisSelected.forEach(function(sa) {
									removeFromAvailable(sa);
								});
							}
							$scope.loading = false;
						}, function(response) {
							// on error
							$scope.loading = false;
						});
					};

					$scope.getRegulations = function() {
						if (!$scope.samplingsAnalysisSelected)
							return [];
						var regulations = [];
						var ids = [];
						for (i = 0; i < $scope.samplingsAnalysisSelected.length; i++) {
							var sa = $scope.samplingsAnalysisSelected[i];
							if (!ids.includes(sa.analysis.regulation.id)) {
								regulations.push(sa.analysis.regulation);
								ids.push(sa.analysis.regulation.id);
							}
						}
						return regulations;
					}

					$scope.getAnalysis = function(r) {
						if (!$scope.samplingsAnalysisSelected)
							return [];
						var analysis = [];
						var ids = [];
						for (i = 0; i < $scope.samplingsAnalysisSelected.length; i++) {
							var sa = $scope.samplingsAnalysisSelected[i];
							if (sa.analysis.regulation.id !== r.id)
								continue;
							if (!ids.includes(sa.analysis.id)) {
								analysis.push(sa.analysis);
								ids.push(sa.analysis.id);
							}
						}
						return analysis;
					}

					$scope.getTechnique = function(a) {
						if (!$scope.samplingsAnalysisSelected)
							return [];

						var techniques = $scope.samplingsAnalysisSelected.filter(function(sa) {
							return (sa.analysis.id === a.id)
						});
						return techniques;
					}

					$scope.onTechniqueSelectChanged = function(technique) {
						modalPopupTrigger();
					}

					$scope.removeTree = function(technique) {
						alertService.showSwtQuestion('Eliminar Análisis de Muestreo "' + technique.name + '"', function() {
							if ($scope.onSamplingAnalysisChange != undefined) {
								$scope.onSamplingAnalysisChange({
									samplingAnalysis : technique,
									typeOperation : 'remove'
								}).then(function() {
									remove(technique);
									alertService.showSuccess('Análisis de Muestreo eliminado satisfactoriamente');
								});
							} else {
								remove(technique);
							}
						});

					}

					$scope.editTree = function(technique) {
						$scope.technique.selected = cloneObject(technique);
						modalPopupTrigger();
					}

					function modalPopup() {
						modal = $uibModal.open({
							templateUrl : 'myModalContent.html',
							backdrop : 'static',
							scope : $scope
						});

						$scope.modalInstance = modal;

						return modal.result
					}
					;

					function modalPopupTrigger() {
						modalPopup().then(function(data) {
							$scope.handleSuccess(data);
						}).then(null, function(reason) {
							$scope.handleDismiss(reason);
						});
					}
					;

					$scope.save = function() {
						$scope.modalInstance.close('Save Button Clicked')
					};

					$scope.close = function() {
						$scope.modalInstance.dismiss('close Button Clicked')
					};

					$scope.handleSuccess = function(data) {
						var technique = $scope.technique.selected;

						if (isSelected(technique)) {
							if ($scope.onSamplingAnalysisChange != undefined) {
								$scope.onSamplingAnalysisChange({
									samplingAnalysis : technique,
									typeOperation : 'update'
								}).then(function(e) {
									update(technique);
									if (!e)
										alertService.showSuccess('Análisis de Muestreo actualizado satisfactoriamente');
								});
							} else {
								update(technique);
							}
						} else {
							if ($scope.onSamplingAnalysisChange != undefined) {
								$scope.onSamplingAnalysisChange({
									samplingAnalysis : technique,
									typeOperation : 'create'
								}).then(function(e) {
									create(technique);
									if (!e)
										alertService.showSuccess('Análisis de Muestreo creado satisfactoriamente');
								});
							} else {
								create(technique);
							}
						}

						$scope.technique = {};
					};

					$scope.handleDismiss = function(reason) {
						$log.info('Modal dismissed: ' + reason);
						$scope.technique = {};
					}

					update = function(technique) {
						var idx = $scope.samplingsAnalysisSelected.findIndex(function(sa) {
							return sa.id === technique.id
						});
						if (idx >= 0)
							$scope.samplingsAnalysisSelected[idx] = technique;
					};

					create = function(samplingAnalysis) {
						$scope.samplingsAnalysisSelected.push(samplingAnalysis);
						removeFromAvailable(samplingAnalysis);
					}

					remove = function(technique) {
						$scope.availableTechniques.unshift(technique);

						var idx = $scope.samplingsAnalysisSelected.findIndex(function(sa) {
							return sa.id === technique.id
						});
						if (idx >= 0)
							$scope.samplingsAnalysisSelected.splice(idx, 1);
					};

					isSelected = function(technique) {
						if (!$scope.samplingsAnalysisSelected)
							return false;

						return $scope.samplingsAnalysisSelected.some(function(m) {
							return m.id === technique.id
						});
					};

					// lo elimina de los posibles técnicas
					removeFromAvailable = function(sa) {
						var index = $scope.availableTechniques.findIndex(function(am) {
							return am.id === sa.id
						});
						if (index >= 0) {
							$scope.availableTechniques.splice(index, 1);
						}
					};

				} ]
	};
};

module.directive('samplingAnalysisSelect', [ samplingAnalysisSelectDirective ]);
